import {Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormGroup, FormGroupDirective} from '@angular/forms';
import {Event} from '@angular/router';
import {TranslocoService} from '@jsverse/transloco';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {take} from 'rxjs/operators';
import {GlobalService} from '../../../../../../../global/global.service';
import {
    SectionEnum
} from '../../../../../documents/document-right-sidebar/add-to-contract-control-modal/add-to-contract-control-modal.component';
import {IDocumentTypesDto} from '../../../../../documents/dto/document-listing.dto';
import {DocumentTypeService} from '../../../../../settings/documenttype/document-type.service';
import {ICCBulkUploadFilesService, IGetExampleFileUrlsResponseDTO, IUploadFilesServiceToken} from '../../upload-files.service';

@Component({
    selector: 'app-upload-files-init-step',
    templateUrl: './upload-files-init-step.component.html',
    styleUrls: ['./upload-files-init-step.component.scss'],
    providers: [FormGroupDirective]
})
export class UploadFilesInitStepComponent implements OnInit, OnDestroy{
    private untilDestroy$: Subject<void> = new Subject<void>();

    @Input() isLoading:boolean = false;
    @Input() submitted:boolean = false;
    @Input() public form: FormGroup;

    @ViewChild('csvFile') csvFile : ElementRef;
    
    documentTypes$: BehaviorSubject<IDocumentTypesDto[]> = new BehaviorSubject<IDocumentTypesDto[]>([]);
    
    @Input() acceptableFiles: string[] = ["application/vnd.ms-excel", "text/csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
    exampleFilesUrl$: Observable<IGetExampleFileUrlsResponseDTO> = this.uploadService.getExampleFileUrls().pipe(take(1));

    constructor(@Inject(IUploadFilesServiceToken) private uploadService: ICCBulkUploadFilesService,
                private globalService: GlobalService,
                private transloco: TranslocoService,
                private documentTypeService: DocumentTypeService,
    ) {
    }

    ngOnInit(): void {
        this.fetchDocumentTypes();
    }

    ngOnDestroy(): void {
        this.untilDestroy$.next();
        this.untilDestroy$.complete();
    }


    onFileDropped($event: FileList | Event) {
        let tempFilesList = [];

        if ($event instanceof Event) {
            tempFilesList = [
                ...(($event.target as HTMLInputElement).files) as unknown as File[]
            ];
        } else {
            tempFilesList = $event as unknown as File[];
        }

        if (tempFilesList.length === 0) {
            return;
        }

        if (tempFilesList.length > 1) {
            this.globalService.toastrWarning(this.transloco.translate('Multiple file upload toast warning (bulk upload first step) - Multiple files has been selected. Only the first one will be taken'));
        }
        
        this.form.get('file')?.setValue(tempFilesList[0]);
    }

    deleteFile() {
        this.form.patchValue({
            file: null
        });

        this.csvFile.nativeElement.value = ''
    }

    private fetchDocumentTypes() {
        this.documentTypeService.getDocumentTypes(1, '', 'all')
            .pipe(take(1))
            .subscribe(x=>this.documentTypes$.next(x as  IDocumentTypesDto[]));
    }

    protected readonly SectionEnum = SectionEnum;
}
